import gql from "graphql-tag";

export const SIMPLE_USER_BADGES_QUERY = gql`
  query userBadgesQuery {
    userBadges {
      badge {
        id
      }
    }
  }
`;

export const SIMPLE_CHALLENGES_QUERY = gql`
  query challengesQuery {
    challenges {
      edges {
        node {
          id
          title
          description
          startDate
        }
      }
    }
  }
`;

export const SIMPLE_BLOCK_CHALLENGES_QUERY = gql`
  query blockChallengesQuery {
    workoutBlocks(type: "CHALLENGE") {
      edges {
        node {
          id
          title
          description
          startDate
        }
      }
    }
  }
`;

export const SIMPLE_CORPORATE_CHALLENGES_QUERY = gql`
  query corporateChallenges {
    corporateChallenges {
      id
      title
      description
      startDate
    }
  }
`;

export const SIMPLE_EVENT_QUERY = gql`
  query event($id: ID!) {
    event(id: $id) {
      id
      name
      scheduledDate
      startTime
    }
  }
`;

export const SIMPLE_EVENTS_QUERY = gql`
  query EventsQuery {
    adminEvents {
      id
      name
      scheduledDate
      startTime
    }
  }
`;

export const ADMIN_BADGES_QUERY = gql`
  query adminBadgesQuery($type: String!, $userId: ID) {
    adminBadges(badgeType: $type, userId: $userId) {
      id
      title
      startDate
      endDate
      description
      iconLink
      isVisible
      isEnabled
      userCount
      userHasBadge
      sendgridTemplateId
      functionValues
      challenge {
        id
        title
        startDate
      }
      blockChallenge {
        id
        title
        startDate
      }
      corporateChallenge {
        id
        title
        startDate
      }
    }
  }
`;

export const UPSERT_COACH_BADGE_MUTATION = gql`
  mutation upsertCoachBadgeMutation($input: BadgeInput!) {
    upsertCoachBadge(input: $input) {
      success
    }
  }
`;

export const AWARD_COACH_BADGE_MUTATION = gql`
  mutation awardCoachBadgeMutation($badgeId: ID!, $userId: ID!, $comment: String!) {
    awardCoachBadge(badgeId: $badgeId, userId: $userId, comment: $comment) {
      success
    }
  }
`;

export const UPSERT_CHALLENGE_BADGE_MUTATION = gql`
  mutation upsertChallengeBadgeMutation($input: BadgeInput!, $challengeInput: ChallengeBadgeInput!) {
    upsertChallengeBadge(input: $input, challengeInput: $challengeInput) {
      success
    }
  }
`;

export const UPSERT_CONSISTENCY_BADGE_MUTATION = gql`
  mutation upsertConsistencyBadgeMutation($input: BadgeInput!, $consistencyInput: ConsistencyBadgeInput!) {
    upsertConsistencyBadge(input: $input, consistencyInput: $consistencyInput) {
      success
    }
  }
`;

export const UPSERT_EVENT_BADGE_MUTATION = gql`
  mutation upsertEventBadgeMutation($input: BadgeInput!, $eventInput: EventBadgeInput!) {
    upsertEventBadge(input: $input, eventInput: $eventInput) {
      success
    }
  }
`;

export const UPSERT_CUSTOM_BADGE_MUTATION = gql`
  mutation upsertCustomBadgeMutation($input: BadgeInput!) {
    upsertCustomBadge(input: $input) {
      success
    }
  }
`;
